import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { ReactComponent as ClockIcon } from '@app/assets/icons/clock-icon.svg';

export interface TimerPracticeRef {
  getTime: () => number;
}

export const TimerPractice = forwardRef<TimerPracticeRef>((_, ref) => {
  const [seconds, setSeconds] = useState(0);
  const [isPaused, setPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [isPaused]);

  // Chuyển đổi giây sang định dạng mm:ss
  const formatTime = (totalSeconds: number) => {
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Cung cấp `getTime` cho component cha
  useImperativeHandle(ref, () => ({
    getTime: () => {
      setPaused(true);
      return seconds;
    },
  }));

  return (
    <div className="flex items-center gap-2">
      <ClockIcon />
      {formatTime(seconds)}
    </div>
  );
});
